import { MKTNLanding } from "@/components/mktn-landing";

const Index = () => {
  return <MKTNLanding />;
};

export default Index;